'use client';

import React from 'react';

interface CreditTierCardProps {
  currentPercentage: string;
}

const tiers = [10, 20, 30, 40];

/**
 * Displays the user's PaySmallSmall credit percentage
 * with tier indicators.
 */
function CreditTierCard({ currentPercentage }: CreditTierCardProps) {
  const currentValue = parseInt(currentPercentage, 10) || 10;

  return (
    <div className="rounded-lg bg-gray-50 p-4">
      <div className="mb-2 flex items-center justify-between">
        <div>
          <p className="font-semibold">PaySmallSmall Credit</p>
          <p className="text-2xl font-bold text-motitoBlue">{currentValue}% credit</p>
        </div>
        <button className="text-sm text-motitoBlue hover:underline">
          Learn more
        </button>
      </div>

      {/* Tier indicators */}
      <div className="flex gap-2">
        {tiers.map((tier) => (
          <div
            key={tier}
            className={`flex-1 rounded-md px-3 py-2 text-center text-sm font-medium transition-colors ${
              currentValue >= tier
                ? 'bg-motitoBlue text-white'
                : 'bg-gray-200 text-gray-600'
            }`}
          >
            {tier}%
          </div>
        ))}
      </div>
    </div>
  );
}

export default CreditTierCard;
